import {phoneNumberValidation} from 'validation/phone';
import * as Yup from 'yup';

export const addPhoneNumberValidation = Yup.object({
  phoneNumber: phoneNumberValidation.required('Please enter a phone number'),
});
